import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { cardHover } from 'src/theme/customEffects'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    compactCoupon: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      '& summary': { cursor: 'pointer', fontSize: '.9rem', padding: '8px 0' },
      '& form': { paddingTop: theme.spacing(1.5) },
      '& label': { display: 'block', fontSize: '.85rem', marginBottom: theme.spacing(.5) },
      '& input': { boxSizing: 'border-box' },
      '& input:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    },
    compactSummary: {
      background: 'transparent',
      boxShadow: 'none',
      '& th, & td': { padding: '10px 0', verticalAlign: 'top' },
      '& td': { paddingLeft: 12, whiteSpace: 'nowrap' },
      '& p': { fontSize: '.9rem', lineHeight: 1.45 },
      '& tr:last-child p': { fontSize: '1.2rem', fontWeight: 700 },
    },

    trFett: {
      '& p': { 
        fontWeight: 'bold',
        fontSize: '1.2em',
      }
    },

    trRed: {
      '& p': { 
        color: `var(--page-builder-error, ${theme.palette.error.dark})`,
      }
    },

    trGreen: {
      '& p': { 
        color: `var(--page-builder-success, ${theme.palette.success.main})`,
      }
    },
    quantityDiscountSummary: {
      color: `var(--page-builder-success, ${theme.palette.success.main})`,
      display: 'grid',
      fontSize: '.88rem',
      gap: theme.spacing(.35),
      lineHeight: 1.35,
      marginTop: theme.spacing(.45),
    },

    couponContainer: {
      padding: theme.spacing(2),
      borderRadius: 4,
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      transition: 'box-shadow 0.3s ease-in-out, border 0.3s ease-in-out',
      marginBottom: theme.spacing(2),
      border: '1px solid transparent',
      '&:hover:not(.valid), &:focus-within:not(.valid)': {
        ...cardHover(theme),
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
      },
      '&.valid': {
        border: `1px solid var(--page-builder-success, ${theme.palette.success.main})`,
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
      },
    },
    couponInput: {
      width: '100%',
      padding: theme.spacing(1),
      fontSize: '1rem',
      borderRadius: 4,
      border: '1px solid #ccc',
      marginBottom: theme.spacing(1),
      '&:focus': {
        borderColor: theme.palette.primary.main,
        outline: 'none', // Entferne den Standard-Outline
      }
    },
    applyButton: {
      width: '100%',
      '&.valid': {
        backgroundColor: `var(--page-builder-success, ${theme.palette.success.main})`,
        color: theme.palette.common.white,
      },
    },
    successText: {
      color: `var(--page-builder-success, ${theme.palette.success.main})`,
    },
    errorText: {
      color: `var(--page-builder-error, ${theme.palette.error.main})`,
    },

  })
)

export default useStyles
